const controlModals = () => {
    const modals = document.querySelectorAll('.modal');
    const modalOpeners = document.querySelectorAll('.modal-trigger a');
    const modalOverlays = document.querySelectorAll('.modal.fade');
    const modalCloseButtons = document.querySelectorAll('.modal-close');
    let redirectTimer = ''

    // Helper function to check cookies safely
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    // Helper function to set cookies safely
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${value}${expires};path=/`;
    }


    // 1. Check if user has already seen the modal
    const hasShown = getCookie("AudienceModalShown");

    if (!hasShown) {
        // 2. Select the modal element (Ensure your HTML has an ID or specific class structure)
        const audienceModal = document.querySelector('.audience');

        if (audienceModal) {
            audienceModal.classList.add('show');

            redirectTimer = setTimeout(() => {
                setCookie("AudienceModalShown", "true", 365); // Set for 1 year
                window.location.href = "https://www.pharming.com";
            }, 15000);
        }
    }

    function hideAllModals(event) {
        console.log('overlay clicked')
        console.log(event)

        if (event.target === event.currentTarget) {
            event.preventDefault()

            console.log('overlay clicked')

            modals.forEach(modal => {
                modal.classList.remove('show');
                
                // Detect if the closing modal is the audience modal
                if (modal.classList.contains('audience')) {
                    setCookie("AudienceModalShown", "true", 365);
                    
                    if (redirectTimer) {
                        clearTimeout(redirectTimer);
                        redirectTimer = null;
                    }
                }
            })
            modalOverlays.forEach(modalOverlaysBack => modalOverlaysBack.classList.remove('show'))
        }
    }

    function getMatchingModal(selectorElement) {

        const selectorClassList = selectorElement.classList;

        
        // Find class that indicates the name (e.g., block_profile--name-aaron)
        // We look for classes starting with "block_profile--name-"
        let identifier = '';
        for (let className of selectorClassList.values()) {
            if (className.startsWith('modal-trigger-')) {
                identifier = className; // e.g., 'block_profile--name-aaron'
                break;
            }
        }

        console.log('identifier')
        console.log(identifier)

        if (!identifier) return null;

        return `.modal-trigger.${identifier}`;
    }

    modalOpeners.forEach(modalOpenersLink => {
        modalOpenersLink.addEventListener('click', (event) => {
            // 1. Open Modal via Trigger Button
            event.preventDefault()

            console.log(event.target.parentElement)

            const modalId = event.target.getAttribute('data-target');
            const modalHref = getMatchingModal(event.target.parentElement) // event.target.getAttribute('href');
            const modal = document.getElementById(modalId);
            // if (modal) modal.classList.add('show');

            console.log(modalHref)

            switch (modalHref) {
                case '.modal-trigger.modal-trigger-haea':
                    const modalHAEA = document.querySelector('.leaving-ruconest-modal');
                    modalHAEA.classList.add('show');
                break;
                // case '.modal-trigger.modal-trigger-audience':
                //     const modalAudience = document.querySelector('.audience');
                //     modalAudience.classList.add('show');
                // break;
                case '.modal-trigger.modal-trigger-reimbursement-request-form':
                    const modalReimbursement = document.querySelector('.reimbursement-request-form');
                    modalReimbursement.classList.add('show');
                break;
                case '.modal-trigger.modal-trigger-program-disclaimer':
                    const modalProgramDisclaimer = document.querySelector('.program-disclaimer');
                    modalProgramDisclaimer.classList.add('show');
                break;
                case '.modal-trigger.modal-trigger-terms-conditions':
                    const modalTermsConditions = document.querySelector('.terms-conditions');
                    modalTermsConditions.classList.add('show');
                break;
                default:
                // Default behavior
                break;
            }
        });
    })

    modalCloseButtons.forEach(modalClosersLink => {
        modalClosersLink.addEventListener('click', hideAllModals);
    })

    modalOverlays.forEach(modalOverlayClosersLink => {
        modalOverlayClosersLink.addEventListener('click', hideAllModals);
    })
}

export { controlModals }